import { Component, OnInit, Input, EventEmitter, Output, SimpleChanges, OnChanges, OnDestroy } from '@angular/core';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { SeaculumAngularFormlyService } from '../../services/saeculum-angular-formly.service';
import { INFO_ICON } from '../../constant/common.constant';
import { FormBaseClass } from '../shared/base-class/form-base-class';

@Component({
    selector: 'saeculum-input-checkbox',
    templateUrl: './checkbox.component.html',
    styleUrls: ['./checkbox.component.scss']
})
export class CheckboxComponent extends FormBaseClass implements OnInit, OnChanges {
    @Input() fieldObj: any;
    @Input() options;
    @Input() values;

    @Input() form: FormGroup;
    @Output() valueChange = new EventEmitter<any>();

    infoIcon = INFO_ICON.icon;

    constructor() {
        super();
    }

    ngOnInit() {
        this.addControl();
    }

    addControl() {
        this.form.addControl(this.fieldObj.key, new FormControl(this.values ? this.values[this.fieldObj.key] : null));
        this.setValidations(this.form, this.fieldObj);
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes && changes.values && changes.values.currentValue && this.form.get(this.fieldObj.key)) {
            this.form.get(this.fieldObj.key).setValue(changes.values.currentValue);
        }
    }

    notifyChange() {
        this.valueChange.emit({ key: this.fieldObj.key, value: this.form.get(this.fieldObj.key).value });
    }
}
